var map = {
	"./AC.svg": 2362,
	"./AD.svg": 18067,
	"./AE.svg": 17595,
	"./AF.svg": 54209,
	"./AG.svg": 14869,
	"./AI.svg": 72622,
	"./AL.svg": 84683,
	"./AM.svg": 70726,
	"./AO.svg": 69923,
	"./AQ.svg": 21482,
	"./AR.svg": 60754,
	"./AS.svg": 41642,
	"./AT.svg": 68622,
	"./AU.svg": 21794,
	"./AW.svg": 60841,
	"./AX.svg": 88361,
	"./AZ.svg": 37058,
	"./BA.svg": 98662,
	"./BB.svg": 1627,
	"./BD.svg": 79735,
	"./BE.svg": 75530,
	"./BF.svg": 88988,
	"./BG.svg": 57294,
	"./BH.svg": 78777,
	"./BI.svg": 73105,
	"./BJ.svg": 97897,
	"./BL.svg": 57194,
	"./BM.svg": 88134,
	"./BN.svg": 64991,
	"./BO.svg": 66930,
	"./BQ.svg": 49304,
	"./BR.svg": 25258,
	"./BS.svg": 97406,
	"./BT.svg": 87721,
	"./BV.svg": 88871,
	"./BW.svg": 39463,
	"./BY.svg": 80438,
	"./BZ.svg": 60294,
	"./CA.svg": 59725,
	"./CC.svg": 44399,
	"./CD.svg": 11294,
	"./CF.svg": 41199,
	"./CG.svg": 6619,
	"./CH.svg": 25786,
	"./CI.svg": 13212,
	"./CK.svg": 59979,
	"./CL.svg": 9063,
	"./CM.svg": 31772,
	"./CN.svg": 80571,
	"./CO.svg": 13892,
	"./CP.svg": 9291,
	"./CR.svg": 36845,
	"./CU.svg": 29112,
	"./CV.svg": 58945,
	"./CW.svg": 67226,
	"./CX.svg": 45738,
	"./CY.svg": 73151,
	"./CZ.svg": 47931,
	"./DE.svg": 99287,
	"./DG.svg": 81319,
	"./DJ.svg": 1711,
	"./DK.svg": 56207,
	"./DM.svg": 89006,
	"./DO.svg": 27239,
	"./DZ.svg": 43675,
	"./EA.svg": 49430,
	"./EC.svg": 66404,
	"./EE.svg": 80840,
	"./EG.svg": 796,
	"./EH.svg": 68016,
	"./ER.svg": 53527,
	"./ES-CT.svg": 94176,
	"./ES-GA.svg": 43266,
	"./ES.svg": 44205,
	"./ET.svg": 5993,
	"./EU.svg": 64326,
	"./FI.svg": 28626,
	"./FJ.svg": 58002,
	"./FK.svg": 46722,
	"./FM.svg": 5593,
	"./FO.svg": 46855,
	"./FR.svg": 20950,
	"./GA.svg": 34526,
	"./GB-ENG.svg": 198,
	"./GB-NIR.svg": 98009,
	"./GB-SCT.svg": 87146,
	"./GB-WLS.svg": 43824,
	"./GB.svg": 87940,
	"./GD.svg": 75156,
	"./GE.svg": 19655,
	"./GF.svg": 41478,
	"./GG.svg": 23273,
	"./GH.svg": 31544,
	"./GI.svg": 12522,
	"./GL.svg": 59728,
	"./GM.svg": 6350,
	"./GN.svg": 76944,
	"./GP.svg": 58621,
	"./GQ.svg": 4017,
	"./GR.svg": 56144,
	"./GS.svg": 59546,
	"./GT.svg": 49110,
	"./GU.svg": 70827,
	"./GW.svg": 79230,
	"./GY.svg": 8802,
	"./HK.svg": 26601,
	"./HM.svg": 96214,
	"./HN.svg": 64155,
	"./HR.svg": 85173,
	"./HT.svg": 93944,
	"./HU.svg": 72815,
	"./IC.svg": 77072,
	"./ID.svg": 42534,
	"./IE.svg": 38178,
	"./IL.svg": 65904,
	"./IM.svg": 43438,
	"./IN.svg": 57482,
	"./IO.svg": 12086,
	"./IQ.svg": 91945,
	"./IR.svg": 1857,
	"./IS.svg": 29727,
	"./IT.svg": 18583,
	"./JE.svg": 97656,
	"./JM.svg": 91697,
	"./JO.svg": 67894,
	"./JP.svg": 77503,
	"./KE.svg": 53449,
	"./KG.svg": 18738,
	"./KH.svg": 21810,
	"./KI.svg": 6841,
	"./KM.svg": 65467,
	"./KN.svg": 56823,
	"./KP.svg": 75863,
	"./KR.svg": 53612,
	"./KW.svg": 11352,
	"./KY.svg": 27598,
	"./KZ.svg": 7034,
	"./LA.svg": 72568,
	"./LB.svg": 73216,
	"./LC.svg": 24966,
	"./LI.svg": 88140,
	"./LK.svg": 82299,
	"./LR.svg": 83194,
	"./LS.svg": 68676,
	"./LT.svg": 46286,
	"./LU.svg": 13331,
	"./LV.svg": 47841,
	"./LY.svg": 40507,
	"./MA.svg": 28227,
	"./MC.svg": 38793,
	"./MD.svg": 5967,
	"./ME.svg": 1032,
	"./MF.svg": 96323,
	"./MG.svg": 34620,
	"./MH.svg": 49056,
	"./MK.svg": 85347,
	"./ML.svg": 89347,
	"./MM.svg": 5142,
	"./MN.svg": 34249,
	"./MO.svg": 5232,
	"./MP.svg": 35854,
	"./MQ.svg": 69999,
	"./MR.svg": 60834,
	"./MS.svg": 98125,
	"./MT.svg": 64769,
	"./MU.svg": 63095,
	"./MV.svg": 98255,
	"./MW.svg": 37512,
	"./MX.svg": 30961,
	"./MY.svg": 74073,
	"./MZ.svg": 73129,
	"./NA.svg": 56362,
	"./NC.svg": 6656,
	"./NE.svg": 42225,
	"./NF.svg": 64304,
	"./NG.svg": 1650,
	"./NI.svg": 53316,
	"./NL.svg": 2771,
	"./NO.svg": 40776,
	"./NP.svg": 83866,
	"./NR.svg": 37442,
	"./NU.svg": 41655,
	"./NZ.svg": 54876,
	"./OM.svg": 19433,
	"./PA.svg": 97918,
	"./PE.svg": 24641,
	"./PF.svg": 7648,
	"./PG.svg": 66528,
	"./PH.svg": 39563,
	"./PK.svg": 6280,
	"./PL.svg": 64632,
	"./PM.svg": 98672,
	"./PN.svg": 89338,
	"./PR.svg": 69587,
	"./PS.svg": 60136,
	"./PT.svg": 95045,
	"./PW.svg": 20124,
	"./PY.svg": 35197,
	"./QA.svg": 89602,
	"./RE.svg": 16969,
	"./RO.svg": 76823,
	"./RS.svg": 57192,
	"./RU.svg": 60637,
	"./RW.svg": 49018,
	"./SA.svg": 37199,
	"./SB.svg": 46922,
	"./SC.svg": 8989,
	"./SD.svg": 63651,
	"./SE.svg": 16975,
	"./SG.svg": 99037,
	"./SH.svg": 38763,
	"./SI.svg": 97390,
	"./SJ.svg": 64501,
	"./SK.svg": 89519,
	"./SL.svg": 62153,
	"./SM.svg": 30623,
	"./SN.svg": 76757,
	"./SO.svg": 71441,
	"./SR.svg": 940,
	"./SS.svg": 80522,
	"./ST.svg": 38751,
	"./SV.svg": 59654,
	"./SX.svg": 93567,
	"./SY.svg": 33291,
	"./SZ.svg": 58666,
	"./TA.svg": 89887,
	"./TC.svg": 29610,
	"./TD.svg": 85456,
	"./TF.svg": 71974,
	"./TG.svg": 85028,
	"./TH.svg": 15793,
	"./TJ.svg": 66738,
	"./TK.svg": 38879,
	"./TL.svg": 61936,
	"./TM.svg": 84109,
	"./TN.svg": 82100,
	"./TO.svg": 57639,
	"./TR.svg": 29073,
	"./TT.svg": 61148,
	"./TV.svg": 56178,
	"./TW.svg": 66008,
	"./TZ.svg": 41739,
	"./UA.svg": 46315,
	"./UG.svg": 86782,
	"./UM.svg": 37672,
	"./UN.svg": 48142,
	"./US.svg": 14650,
	"./UY.svg": 91682,
	"./UZ.svg": 84746,
	"./VA.svg": 11662,
	"./VC.svg": 91530,
	"./VE.svg": 79864,
	"./VG.svg": 12911,
	"./VI.svg": 93112,
	"./VN.svg": 24941,
	"./VU.svg": 15329,
	"./WF.svg": 69420,
	"./WS.svg": 33585,
	"./XK.svg": 95490,
	"./XX.svg": 23361,
	"./YE.svg": 79164,
	"./YT.svg": 65051,
	"./ZA.svg": 25656,
	"./ZM.svg": 26275,
	"./ZW.svg": 57290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61228;